import React, {useState,useEffect,useCallback,useMemo} from "react";
import Card from "../components/Card";
import Button from "../components/Button";
import Input from "../components/Input";
import Navbar from "../components/Navbar";
import { apiUrl } from "../utils/api";

function Attendance({ setPage }) {
  const [status, setStatus] = useState("");
  const [workingUsers, setWorkingUsers] = useState([]);
  const [employeeId, setEmployeeId] = useState("");
  const [employeeName, setEmployeeName] = useState("");
  const isWorking = status === "working";
  const isBreak = status === "break";
  const canClockIn = employeeId && !isWorking && !isBreak;
  const canStartBreak = employeeId && isWorking;
  const canEndBreak = employeeId && isBreak;
  const canClockOut = employeeId && isWorking;
  const token = localStorage.getItem("token");
  const authHeaders = useMemo(
    () => (token ? { Authorization: `Bearer ${token}` } : {}),
    [token]
  );
  const statusView = {
    working: { label: "出勤中", bg: "#dcfce7", color: "#166534" },
    break: { label: "休憩中", bg: "#fef3c7", color: "#92400e" },
    finished: { label: "退勤済み", bg: "#e0e7ff", color: "#3730a3" },
    offline: { label: "未出勤", bg: "#f3f4f6", color: "#4b5563" },
    "": { label: "未入力", bg: "#f3f4f6", color: "#4b5563" },
  }[status || ""] || { label: "未出勤", bg: "#f3f4f6", color: "#4b5563" };
  // =========================
  // 勤怠状態取得
  // =========================
  const fetchStatus = useCallback(
    async () => {
      if (!employeeId) {
        setStatus("");
        return;
      }
      try {
	        const res = await fetch(
	          apiUrl("/attendance-status"),
          {
            method: "POST",
            headers: {"Content-Type":"application/json", ...authHeaders},
            body: JSON.stringify({
              employeeId,
            }),
          }
        );
        const data = await res.json();
        setStatus(data.status);
      } catch (error) {
        console.error(error);
      }
    }, [employeeId, authHeaders]
  );


  // =========================
  // 勤怠状態取得
  // =========================
  useEffect(() => {
      const fetchEmployee = async () => {
        if (!employeeId) {
          setEmployeeName("");
          return;
        }
        try {
          const token = localStorage.getItem("token");
	          const res = await fetch(
	            apiUrl(`/user-name/${employeeId}`),
            {
              headers: {Authorization: `Bearer ${token}`,},
            }
          );
          if (!res.ok) {
            setEmployeeName("");
            return;
          }
          const data = await res.json();
          setEmployeeName(data.name);
        } catch (error) {
          console.error(error);
          setEmployeeName("");
        }
      };
      fetchEmployee();
    }, [employeeId]);

  // =========================
  // 出勤中一覧取得
  // =========================
  const fetchWorkingUsers = useCallback(async () => {
      try {
        const res = await fetch(apiUrl("/working-users"), {
          headers: { ...authHeaders },
        });
        const data = await res.json();
        setWorkingUsers(data);
      } catch (error) {
        console.error(error);
      }
    }, [authHeaders]
  );
  // =========================
  // 出勤
  // =========================
  const handleClockIn = async () => {
      try {
	        const res = await fetch(
	          apiUrl("/clock-in"),
          {
            method: "POST",
            headers: {"Content-Type":"application/json", ...authHeaders},
            body: JSON.stringify({
              employeeId,
            }),
          }
        );
        const data =await res.json();
        alert(data.message);
        await fetchStatus();
        await fetchWorkingUsers();
      } catch (error) {
        console.error(error);
        alert("出勤エラー");
      }
    };

  // =========================
  // 退勤
  // =========================
  const handleClockOut = async () => {
      try {
	        const res = await fetch(
	          apiUrl("/clock-out"),
          {
            method: "POST",
            headers: {"Content-Type":"application/json", ...authHeaders},
            body: JSON.stringify({
              employeeId,
            }),
          }
        );
        const data = await res.json();
        alert(data.message);
        await fetchStatus();
        await fetchWorkingUsers();
      } catch (error) {
        console.error(error);
        alert("退勤エラー");
      }
    };

  // =========================
  // 休憩開始
  // =========================
  const handleBreakStart =
    async () => {
      try {
	        const res = await fetch(
	          apiUrl("/break-start"),
          {
            method: "POST",
            headers: {"Content-Type":"application/json", ...authHeaders},
            body: JSON.stringify({
              employeeId,
            }),
          }
        );

        const data = await res.json();
        alert(data.message);
        await fetchStatus();
        await fetchWorkingUsers();
      } catch (error) {
        console.error(error);
        alert("休憩開始エラー");
      }
    };

  // =========================
  // 休憩終了
  // =========================
  const handleBreakEnd =async () => {
      try {
	        const res = await fetch(
	          apiUrl("/break-end"),
          {
            method: "POST",
            headers: {"Content-Type": "application/json", ...authHeaders},
            body: JSON.stringify({
              employeeId,
            }),
          }
        );

        const data = await res.json();
        alert(data.message);
        await fetchStatus();
        await fetchWorkingUsers();
      } catch (error) {
        console.error(error);
        alert("休憩終了エラー");
      }
    };

  //=========================
  // ログアウト
  // =========================
  const handleLogout = () => {localStorage.clear();setPage("shop-login");};

  // =========================
  // 初回読み込み
  // =========================
  useEffect(() => {fetchWorkingUsers();}, [fetchWorkingUsers]);
  // =========================
  // 社員番号変更時
  // =========================
  useEffect(() => {fetchStatus();}, [employeeId, fetchStatus]);
  const actionButtons = [
    { label: "出勤", color: "green", enabled: canClockIn, onClick: handleClockIn },
    { label: "休憩開始", color: "yellow", enabled: canStartBreak, onClick: handleBreakStart },
    { label: "休憩終了", color: "blue", enabled: canEndBreak, onClick: handleBreakEnd },
    { label: "退勤", color: "red", enabled: canClockOut, onClick: handleClockOut },
  ];
  // =========================
  // 表示
  // =========================
	  return (
	    <div>
	      <Navbar />
	      <main className="page-shell" style={{ maxWidth: "980px", }}>
	    <Card className="p-5 sm:p-6">
	      <div style={{ display: "flex", justifyContent: "space-between", gap: "16px", alignItems: "start", flexWrap: "wrap", }}>
	        <div>
	          <h2 style={{ margin: 0, fontSize: "28px", fontWeight: 800, }}>出退勤</h2>
	          <p style={{ margin: "6px 0 0", color: "#64748b", }}>社員番号を入力して勤務状態を打刻します。</p>
	        </div>
	        <span style={{ background: statusView.bg, color: statusView.color, borderRadius: "999px", padding: "10px 16px", fontWeight: 800, fontSize: "15px", }}>
	          {statusView.label}
	        </span>
	      </div>
	      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(min(240px, 100%), 1fr))", gap: "16px", marginTop: "24px", }}>
	        <label style={{ fontSize: "13px", fontWeight: 700, color: "#334155", }}>
	          社員番号
	          <Input className="mt-1 w-full text-lg font-semibold" placeholder="社員番号" value={employeeId} onChange={(e) => setEmployeeId( e.target.value)}/>
	        </label>
	        <div style={{ background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: "8px", padding: "12px 14px", minHeight: "58px", }}>
	          <p style={{ margin: 0, color: "#64748b", fontSize: "12px", fontWeight: 700, }}>名前</p>
	          <strong style={{ fontSize: "18px" }}>{employeeName || "-"}</strong>
	        </div>
	      </div>

      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(min(150px, 100%), 1fr))", gap: "12px", marginTop: "22px",}}>
          {actionButtons.map((action) => (
            <Button
              key={action.label}
              color={action.color}
              size="full"
              onClick={action.onClick}
              disabled={!action.enabled}
              className="min-h-[64px] text-base"
            >
              {action.label}
            </Button>
          ))}
	      </div>
        <div style={{ display: "flex", gap: "10px", marginTop: "18px", flexWrap: "wrap" }}>
          <Button color="light" size="auto" onClick={() => setPage("login")}>シフト画面へ戻る</Button>
          <Button color="red" size="auto" onClick={handleLogout}>ログアウト</Button>
        </div>
	    </Card>
	      {/* 出勤中一覧 */}
	      <Card className="p-5">
	        <h3 style={{ margin: "0 0 12px", fontSize: "18px", fontWeight: 800, }}>出勤中スタッフ</h3>
	        {workingUsers.length === 0 ? (
	          <p style={{ color: "#64748b", margin: 0, }}>現在出勤中のスタッフはいません</p>
	        ) : (
	          <ul style={{ listStyle: "none", margin: 0, padding: 0, display: "grid", gap: "8px", }}>
	            {workingUsers.map((user) => (
	              <li key={user.id} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: "12px", padding: "12px 14px", background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: "8px", }}>
	                <strong>{user.name}</strong>
	                <span style={{ borderRadius: "999px", padding: "4px 8px", fontSize: "12px", fontWeight: 700, background: user.status === "break" ? "#fef3c7" : "#dcfce7", color: user.status === "break" ? "#92400e" : "#166534", }}>
	                  {user.status === "break"? "休憩中" : "勤務中"}
	                </span>
	              </li>
	              ))}
	          </ul>
	        )}
	      </Card>
	      </main>
	    </div>
	  );
}

export default Attendance;
